import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { Close } from '@mui/icons-material';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import './ModalEditWindow.css';

import 'react-toastify/dist/ReactToastify.css';
import { closeRequestModal } from '../../actions/modals';
import usePhoneCheck from '../../hooks/usePhoneCheck';

const switcherSchema = {
    SpeedTableModal: 'lg',
    GroupHistoryModal: 'md',
    statisticsData: 'lg',
    PaymentHistoryModal: 'md',
    ActiveTransactions: 'lg',
    SorokoinsForHomework: 'lg',
    AllActiveTransactions: 'lg',
    AllActiveRootTransactions: 'lg',
    AllActiveOrders: 'lg',
    Cart: 'md',
    OrderedProducts: 'lg',
    SupportChat: '2xl',
    SupportChatСlient: 'md',
    TransactionHistory: 'lg',
    OrderHistory: 'lg',
    MoneyBox: 'lg',
    AddNews: 'md',
    ViewNews: 'md',
    CreateQuiz: 'md',
    EditQuiz: 'md',
    GroupHistoryHw: 'md',
    Quests: 'lg',
};

const isModalHaveProps = ['PreventRouterModal'];

const ModalEditWindow = React.memo(props => {
    const [modalComponent, setModalComponent] = useState(null);
    const [modalType, setModalType] = useState(null);

    const chatId = useSelector(state => state.suppotrChat.activeChat);

    useEffect(() => {
        processModalUpdate();
    }, [props.requestmodal]);

    async function processModalUpdate() {
        const { data } = props.requestmodal;

        if (data && data.modaltype) {
            const { modaltype } = data;
            try {
                const module = await import(`./modalComponents/${modaltype}`);
                const ModalComponent = module.default;
                const propsToPass = isModalHaveProps.includes(modaltype) ? props : {};
                const newModalComponent = <ModalComponent data={data} {...propsToPass} />;
                setModalComponent(newModalComponent);
                setModalType(modaltype);
            } catch (error) {
                console.error(`Could not load component for type "${modaltype}"`, error);
                setModalComponent(null);
                setModalType(null);
            }
        } else {
            setModalComponent(null);
            setModalType(null);
        }
    }

    const { requestmodal, closeRequestModal, modal, theme } = props;
    const { opened, data } = requestmodal;

    const animations = modal.usermenu ? 'animated fadeOut' : 'animated fadeIn';
    const mobile = usePhoneCheck();
    const modalWidth = mobile ? 'lg' : switcherSchema[data?.modaltype] || 'xs';
    const supportChat = modalType === 'SupportChat' || modalType === 'SupportChatСlient';
    return (
        <Dialog
            fullWidth={true}
            fullScreen={mobile || supportChat}
            maxWidth={mobile ? false : modalWidth}
            open={opened || false}
            onClose={closeRequestModal}
            className={`panel-back themeColor${theme.toUpperCase()} ${modal.switch || animations}`}
        >
            <DialogTitle display="flex" justifyContent={'space-between'} alignItems={'center'}>
                <Typography>{opened && data?.header}</Typography>
                <IconButton id="close_modal-button" aria-label="close" onClick={closeRequestModal}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent
                style={{
                    paddingBottom: mobile ? 120 : 50,
                    paddingTop: 10,
                }}
                data-testid={`modal-content-${modalComponent?.props?.data?.modaltype}` || 'modal-content-empty'}
            >
                {modalComponent}
            </DialogContent>
        </Dialog>
    );
});

const widthConnect = connect(
    state => ({
        user: state.user,
        requestmodal: state.modalWindow.requestmodal,
        modal: state.modalWindow,
        theme: state.user && state.user.theme,
    }),
    dispatch =>
        bindActionCreators(
            {
                closeRequestModal,
            },
            dispatch
        )
);

export default widthConnect(ModalEditWindow);
